const setSliderWrapperHeight = (wrapper, slides) => {
  let max = 0;
  slides.each((i, e) => {
    const curr = $(e);
    const currHeight = curr.outerHeight(true);
    if (currHeight > max) {
      max = currHeight;
    }
  });
  // Define height for sliderWrapper
  console.log(max);
  wrapper.height(max);
};

const testimSlider = () => {
  const block = $(".block-testimonials-slider");
  if (block.length) {
    const bullets = block.find(".container-fluid .square-bullets-pagination > span");
    const sliderWrapper = block.find(".container-fluid .slider-wrapper");
    const slides = sliderWrapper.children();
    
    setSliderWrapperHeight(sliderWrapper, slides);

    $(window).on('resize',() => {
      setSliderWrapperHeight(sliderWrapper, slides);
    })

    bullets.on("click", (e) => {
      const self = $(e.target);
      console.log(self);
      self.siblings().removeClass("active");
      self.addClass("active");
      slides.removeClass("active");
      slides.eq(self.index()).addClass("active");
    });
  }
};

export default testimSlider;
